let cn = {
    CONNECTFAIL: "请检查服务器是否连接成功！",
    CHECKCONNECTED: "请检查服务器是否连接！",
    HAVENOSUCHTENDER: "没有找到对应的标书！",
    LOGINFAILED: "用户标识和密码无效。请重新尝试。",
    APPROPRIATEVALUE: "请输入合适的值。",
    CONFIRMUNITPRICE: "请确认以下条款编号的单价：",
    QUOTEFAILED: "该报价单已经报价，不能重复报价。",
    UPLOADSUCCESSFULLY: "上传成功！",
    UPLOADFAILED: "上传失败！",
    SUCCESS: "成功",
    FAILURE: "失败",
    RESETFAILED_NOTDIFF: "新密码不能跟原密码相同，请重新设置",
    RESETFAILED_NOTMEET: "新密码不符合规范 ，请重新设置",
    RESET_SUCC: "重置密码成功 返回登录页面",
    VERCODE_ERROR:"验证码错误",
    NOTEXIST:'用户不存在，请检查用户名是否正确',
    CONFIRMREQUIRE:'请确认以下条款的必填项是否已经填写正确：',
    CANNOTUPLOAD:'Attachment cannot be uploaded in current status',
    TENDERISOVERDUE:'The tender has expired. Please return to the list page and refresh the page to get the latest status of the tender',
    CONFIRMZERO:'Please confirm whether the price of the input box of the following lines is greater than zero:',
    MUSTUPLOADFILE:'You must upload at least 1 attachment to submit the tender '
};
let tw = {
    CONNECTFAIL: "請檢查服務器是否連接成功！",
    CHECKCONNECTED: "請檢查服務器是否連接！",
    HAVENOSUCHTENDER: "沒有找到對應的標書！",
    LOGINFAILED: "用戶標識和密碼無效。請重新嘗試。",
    APPROPRIATEVALUE: "請輸入合適的值。",
    CONFIRMUNITPRICE: "請確認以下條款編號的單價：",
    QUOTEFAILED: "該報價單已經報價，不能重複報價。",
    UPLOADSUCCESSFULLY: "上傳成功！",
    UPLOADFAILED: "上傳失敗！",
    SUCCESS: "成功",
    FAILURE: "失敗",
    RESETFAILED_NOTDIFF: "新密碼不能跟原密碼相同，請重新設定",
    RESETFAILED_NOTMEET: "新密碼不符合規範，請重新設定",
    RESET_SUCC: "重置密碼成功 返回登入頁面",
    VERCODE_ERROR:"驗證碼錯誤",
    NOTEXIST:'用戶不存在，請檢查用戶名是否正確',
    CONFIRMREQUIRE:'請確認一下條款的必填項是否已經填寫正確：',
    CANNOTUPLOAD:'Attachment cannot be uploaded in current status',
    TENDERISOVERDUE:'The tender has expired. Please return to the list page and refresh the page to get the latest status of the tender',
    CONFIRMZERO:'Please confirm whether the price of the input box of the following lines is greater than zero:',
    MUSTUPLOADFILE:'You must upload at least 1 attachment to submit the tender '
};
let en = {
    CONNECTFAIL: "Please check whether the server is connected successfully.",
    CHECKCONNECTED: 'Please check if the server is connected!',
    HAVENOSUCHTENDER: 'Have no such tender!',
    LOGINFAILED: "User ID and password are invalid. Please try again.",
    APPROPRIATEVALUE: "Please enter the appropriate value.",
    CONFIRMUNITPRICE: "Please confirm the unit price of the following article number:",
    QUOTEFAILED: "The quotation has been quoted and cannot be quoted repeatedly.",
    UPLOADSUCCESSFULLY: "Uploaded successfully!",
    UPLOADFAILED: "Upload failed!",
    SUCCESS: "Success",
    FAILURE: "Failure",
    RESETFAILED_NOTDIFF: "The new password cannot be the same as the original password. Please reset it",
    RESETFAILED_NOTMEET: "The new password does not meet the specification, please reset it",
    RESET_SUCC: "Reset password successfully and return to login page",
    VERCODE_ERROR: "Verification code error",
    NOTEXIST:'The user does not exist, please check if the user name is correct',
    CONFIRMREQUIRE:'Please confirm whether the required items of the terms have been filled in correctly:',
    CANNOTUPLOAD:'Attachment cannot be uploaded in current status',
    TENDERISOVERDUE:'The tender has expired. Please return to the list page and refresh the page to get the latest status of the tender',
    CONFIRMZERO:'Please confirm whether the price of the input box of the following lines is greater than zero:',
    MUSTUPLOADFILE:'You must upload at least 1 attachment to submit the tender '
}

export {
    cn,
    tw,
    en
}